import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeatureFeed from "./components/FeatureFeed";
import DimensionWall from "./components/DimensionWall";
import TopicWall from "./components/TopicWall";
import SuspicionBoard from "./components/SuspicionBoard";
import MethodSection from "./components/MethodSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans">
      <Navbar />
      <main className="w-full">
        <Hero />
        <FeatureFeed />
        <DimensionWall />
        <TopicWall />
        <SuspicionBoard />
        <MethodSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}